import Reveal from 'reveal.js';
import Markdown from 'reveal.js/plugin/markdown/markdown.esm'
import SpeakerNotes from 'reveal.js/plugin/notes/notes.esm'
import RevealHighlight from 'reveal.js/plugin/highlight/highlight.esm';

let deck = new Reveal({
   plugins: [
      Markdown,
      SpeakerNotes,
      RevealHighlight,
   ],
   progress: false,
   pdfSeparateFragments: false,
})

deck.initialize();
